var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPyronix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 372.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d20a11;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.58,209.82v72.76h-27V103.42h30.63q22.51,0,34,3.13a45.66,45.66,0,0,1,20.42,11.84Q353,133.48,353,156.45q0,24.6-16.47,39t-44.45,14.38Zm0-25.06h10.1q37.24,0,37.25-28.66,0-27.73-38.41-27.73h-8.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416,261.58l-50.82-92h30.28l34.58,65,32.26-65H491.8l-90,174.52H371.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.05,169.56h26.11v10.1q7.19-7.54,12.76-10.33a29.33,29.33,0,0,1,13.46-2.9q10.33,0,21.58,6.73l-12,23.9q-7.43-5.34-14.5-5.34-21.36,0-21.35,32.26v58.6H500.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.19,225.26a56.17,56.17,0,0,1,17.52-41.66q17.52-17.17,42.7-17.17t42.93,17.29q17.42,17.28,17.41,42.47,0,25.41-17.52,42.58T632,285.83q-25.41,0-42.59-17.41Q572.18,251.26,572.19,225.26Zm26.69.46q0,17,9,26.81,9.29,10,24.48,10t24.48-9.87q9.17-9.85,9.17-26.34T656.89,200q-9.27-10-24.48-10-15,0-24.25,10T598.88,225.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M706.35,169.56h26.22V180q13.7-13.58,30.86-13.57,19.73,0,30.75,12.41,9.52,10.56,9.52,34.47v69.27H777.48V219.46q0-16.71-4.65-23.1t-16.47-6.49q-13,0-18.45,8.58T732.57,228v54.54H706.35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M816.07,122.57A17,17,0,0,1,833,105.74a16.46,16.46,0,0,1,12.07,5,16,16,0,0,1,5,12,16.43,16.43,0,0,1-5,12.07,16,16,0,0,1-12,5,16.43,16.43,0,0,1-12.07-5A16.61,16.61,0,0,1,816.07,122.57Zm30.06,47v113H820v-113Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.73,221.43l-40.61-51.87h31.1l25.18,33,25.64-33h32L936.3,221.43l48.38,61.15H953.59L920.4,240.34l-34,42.24H854.49Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.02 39.8 142.73 86.17 142.73 305.28 80.67 194.11 80.67 100.76 31.02 60.15 31.02 39.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.42 119.82 75.75 328.79 75.75 103.31 12.42 46.82 12.42 119.82"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.67 30.88 202.29 57.59 202.29 282.44 147.71 216.99 147.71 79.79 49.67 44.27 49.67 30.88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.79,33.26a8.52,8.52,0,1,0,8.52,8.51,8.53,8.53,0,0,0-8.52-8.51m0,18.59a10.08,10.08,0,1,1,10.07-10.08,10.08,10.08,0,0,1-10.07,10.08"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217,41.52h1.23c1.28,0,2.1-.7,2.1-1.77S219.42,38,218.15,38a4.65,4.65,0,0,0-1.19.11Zm-1.21-4.25a13,13,0,0,1,2.31-.19,3.84,3.84,0,0,1,2.7.76,2.33,2.33,0,0,1,.73,1.77A2.44,2.44,0,0,1,219.73,42v0a2.32,2.32,0,0,1,1.37,1.88,15.81,15.81,0,0,0,.72,2.56h-1.24a11.87,11.87,0,0,1-.62-2.23c-.28-1.28-.78-1.77-1.87-1.81H217v4h-1.21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyronix);
export default __webpack_public_path__ + "static/media/pyronix.575f864cde0bb25ce74d745521d3203d.svg";
export { ForwardRef as ReactComponent };